import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';

interface PayoutsRegisterModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Placeholder modal shown when a chef taps "Total earned:" on the Pending
 * segment before payouts registration is live. Same copy is used inline on
 * the Paid Out segment (extracted into PayoutsRegisterPlaceholder for reuse).
 *
 * Ships hardcoded until the payouts registration flow lands — the italic
 * date line + disabled button both drop then.
 */
export const PayoutsRegisterModal: React.FC<PayoutsRegisterModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation('profile');
  return (
    // hideCloseButton: the explicit Close button below + click-backdrop
    // dismiss cover the same intent as the built-in X, so hiding the X
    // removes the visual clutter (and the overlap it was causing with the
    // first line of copy at Modal's default padding).
    <Modal isOpen={isOpen} onClose={onClose} size="sm" hideCloseButton>
      <PayoutsRegisterPlaceholder />
      <p className="mt-3 text-right">
        <button
          type="button"
          onClick={onClose}
          className="text-sm font-medium text-muted-foreground hover:text-foreground"
        >
          {t('earnings.close')}
        </button>
      </p>
    </Modal>
  );
};

/**
 * The Paid Out empty state — reused as the modal body above. Kept as a
 * single component so the two surfaces can't drift.
 */
export const PayoutsRegisterPlaceholder: React.FC = () => {
  const { t } = useTranslation('profile');
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-foreground">{t('earnings.notRegistered')}</p>
      <button
        type="button"
        disabled
        className="w-full rounded-xl bg-brand-primary px-4 py-2.5 text-sm font-semibold text-white opacity-50"
      >
        {t('earnings.registerCta')}
      </button>
      <p className="text-center text-xs italic text-muted-foreground">
        {t('earnings.registrationOpens')}
      </p>
    </div>
  );
};
